(function () {
	'use strict';
	angular.module('app.myWork', ['ui.sortable']);
})();